<template>
  <!-- 贵族弹窗 -->
  <el-dialog title="" :visible.sync="visible" class="noble-dialog" :close-on-click-modal="true" :before-close="close">
    <div class="content">
      <div class="content-header">
        <div
          @click="changeTab(item.id, index, item.name)"
          class="header-item"
          :class="isActive == item.id ? 'header-item-active' : ''"
          v-for="(item, index) in nobleList"
          :key="item.id"
        >
          <img class="select" v-show="userInfo.noble_id == index + 1" src="@/assets/img/dialog/noble-select.png" alt="" />
          <img class="img" :src="item.pic" />
          <div class="text">{{ item.name }}</div>
          <div class="mask"></div>
        </div>
      </div>
      <div class="bar"></div>
      <div class="content-panel">
        <div class="content-panel-left">
          <img class="img" :src="leftPic" />
        </div>
        <div class="content-panel-right">
          <div class="right-item" v-for="(item, index) in contentList" :key="index">
            <img :src="item.icon" />
            <div class="text1">{{ item.title }}</div>
            <div class="text2">{{ item.desc1 }}</div>
            <div class="text3">{{ item.desc2 }}</div>
          </div>
        </div>
      </div>
      <div class="bar"></div>
      <div class="content-footer">
        <div class="content-footer-left">
          <div class="up">
            <div>
              开通{{ tabName }}：<span>{{ nobleList[tabIndex] ? (nobleList[tabIndex].price / 100).toLocaleString() : "" }}</span> 克拉/月&nbsp;&nbsp;
            </div>
            <div>
              续费价格：<span>{{ nobleList[tabIndex] ? (nobleList[tabIndex].renew_price / 100).toLocaleString() : "" }}</span> 克拉/月
            </div>
          </div>
          <div class="down">
            克拉余额：<span>{{ (userInfo.diamond / 100).toLocaleString() }}</span> 克拉
          </div>
        </div>
        <div class="content-footer-right" @click="charge()">
          <img v-show="!(userInfo.noble_id > isActive)" class="btn" src="../../assets/img/dialog/button.png" alt="" />
          <img class="text" v-show="!userInfo.noble_id" src="../../assets/img/dialog/start.png" alt="" />
          <img class="text" v-show="userInfo.noble_id === isActive" src="../../assets/img/dialog/continue.png" alt="" />
          <img class="text" v-show="userInfo.noble_id < isActive && userInfo.noble_id != 0" src="../../assets/img/dialog/upgrade.png" alt="" />
        </div>
      </div>
      <div class="e-line-panel">
        <img class="e-line" src="../../assets/img/dialog/e-line.png" />
      </div>
    </div>
    <el-dialog top="30vh" class="watch-dialog" center :visible.sync="isCharge" append-to-body>
      <div class="confirm">
        <div class="header">确认开通</div>
        <div class="dia-content">
          <div class="text" v-if="userInfo.noble_id !== isActive">
            <div v-show="userInfo.noble_id > 0">
              您目前已经是{{ currentNobleName }}贵族，开通{{ tabName }}贵族后，您的特权会自动升级到{{ tabName }}贵族，{{
                currentNobleName
              }}贵族特权不会保留（坐骑除外），您确定开通{{ tabName }}贵族吗？
            </div>
            <div v-show="userInfo.noble_id == 0">您确定开通{{ tabName }}贵族吗？</div>
          </div>
          <div v-else>您确定续费{{ tabName }}贵族吗？</div>
        </div>
        <div class="dialog-footer">
          <el-button class="cancel" @click="isCharge = false" round>取 消</el-button>
          <el-button class="commit" type="primary" round @click="chargeNoble()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog top="30vh" class="watch-dialog" center :visible.sync="isGoToCharge" append-to-body>
      <div class="confirm">
        <div class="header">余额不足 立即充值</div>
        <div class="dialog-footer">
          <el-button class="cancel" @click="isGoToCharge = false" round>取 消</el-button>
          <el-button class="commit" type="primary" round @click="GoToRecharge()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  props: {
    anchor: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      visible: false,
      isCharge: false,
      isGoToCharge: false,
      nobleList: [],
      tabPic: [
        require("../../assets/img/dialog/noble2.png"),
        require("../../assets/img/dialog/noble4.png"),
        require("../../assets/img/dialog/noble6.png"),
      ],
      contentList: [],
      isActive: 1,
      isNoble: false,
      leftPic: require("../../assets/img/dialog/noble2.png"),
      noblePrice: [],
      tabIndex: 0,
      tabName: "骑士",
      currentNobleName: "骑士",
    };
  },
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    ...mapActions(["getUserInfo"]),
    ...mapMutations(["toggleLogin"]),

    GoToRecharge() {
      this.$router.push("/user-center/index");
    },

    open() {
      this.visible = true;
      this.getNobleList();
      // this.getNobleById();
      // this.getNoblePriceList();
    },
    close() {
      this.visible = false;
    },
    charge() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      this.isCharge = true;
    },
    changeTab(id, index, name) {
      this.formatContentList(this.nobleList[index]);
      this.isActive = id;
      this.leftPic = this.tabPic[index];
      this.tabIndex = index;
      this.tabName = name;
      // this.isRenew = this.noblePrice[this.tabIndex].is_renew;
    },
    async chargeNoble() {
      try {
        const { data } = await post({ url: "/api/noble/chargeNoble", data: { anchor_id: this.anchor.id, id: this.isActive } });
        if (data.status == 0) {
          this.$message.success("开通成功");
          this.isCharge = false;
          this.visible = false;
          this.getUserInfo();
          this.$emit("reloadBackpack");
        }
      } catch (error) {
        console.log(error);
        if (error == "Error: 您的克拉余额不足,请充值后继续") {
          this.isCharge = false;
          this.isGoToCharge = true;
        }
      }
    },

    async getNobleList() {
      const {
        data: { data },
      } = await post({ url: "/api/noble/getNobleList" });
      // this.nobleList = data.reverse();
      this.nobleList = data;
      if (this.userInfo.noble_id > 0) {
        this.tabIndex = this.userInfo.noble_id - 1;
        this.isActive = this.userInfo.noble_id;
        this.leftPic = this.tabPic[this.tabIndex];
      }
      console.log(this.tabIndex, "this.tabIndex");
      this.formatContentList(this.nobleList[this.tabIndex]);
      console.log(this.contentList, "this.contentList");
      for (let i = 0; i < this.nobleList.length; i++) {
        this.nobleList[i].pic = this.tabPic[i];
      }
    },
    formatContentList(obj) {
      let danmu = 0;
      obj.barrage_detail.forEach((e) => {
        danmu += e.amount;
      });
      let arr1 = { icon: require("../../assets/img/dialog/item-1.png"), title: "万众瞩目", desc1: "贵族专属身份", desc2: obj.name + "徽章耀眼夺目" };
      let arr2 = {
        icon: obj.mount_detail.icon ? obj.mount_detail.icon : require("../../assets/img/dialog/zj-1.png"),
        title: "专属坐骑",
        desc1: obj.mount_detail.name,
        desc2: "高级入场特效",
      };
      let arr3 = {
        icon: require("../../assets/img/dialog/item-4.png"),
        title: "发言特权",
        desc1: "尊享" + obj.barrage_detail.length + "种炫彩",
        desc2: "弹幕" + danmu + "个",
      };
      let arr4 = {
        icon: require("../../assets/img/dialog/item-9.png"),
        title: "喇叭",
        desc1: obj.trumpet_detail.amount + "个免费广告弹幕",
        desc2: "发言神器",
      };
      let arr5 = {
        icon: require("../../assets/img/dialog/item-10.png"),
        title: "礼物折扣",
        desc1: "直播间刷礼物",
        desc2: `尊享${obj.gift_discount / 10}折`,
      };
      let arr6 = { icon: require("../../assets/img/dialog/item-3.png"), title: "VIP客服", desc1: "24小时", desc2: "专人在线服务" };
      this.contentList = [arr1, arr2, arr3, arr4, arr5, arr6];
    },
  },
};
</script>

<style scoped lang="scss">
.watch-dialog {
  ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      // width: 3.63rem;
      // height: 2.66rem;
      // display: flex;
      // flex-direction: column;
    }
    .el-dialog {
      width: 3.63rem;
      height: 2.66rem;
      border-radius: 0.1rem;
    }
  }
  .confirm {
    height: 2.66rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0.2rem 0.44rem;
    .header {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 500;
      font-size: 0.2rem;
      text-align: center;
    }
    .dia-content {
      color: #333333;
      font-size: 0.16rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.16rem;
        line-height: 0.22rem;
      }
    }
    .cancel,
    .cancel:hover {
      border-color: #02a8a2;
      color: #02a8a2;
      padding: 0.1rem 0.45rem;
    }
    .commit,
    .commit:hover {
      background-color: #02a8a2;
      color: #ffffff;
      border-color: #02a8a2;
      padding: 0.1rem 0.45rem;
    }
  }
}
.noble-dialog {
  z-index: 1;
  ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      // height: 5.74rem;
    }
    .el-dialog {
      width: 8.26rem;
    }
  }

  .content {
    position: relative;
    width: 8.26rem;
    .bar {
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, rgba(64, 63, 60), rgba(64, 63, 60, 0.8), rgba(64, 63, 60));
    }
    .content-header {
      background: #23242f;
      height: 0.96rem;
      z-index: 2;
      display: flex;
      justify-content: space-around;
      padding: 0 1rem;
      .header-item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 0.84rem;
        height: 0.96rem;
        cursor: pointer;
        // margin-right: 0.26rem;
        .text {
          margin-top: 0.02rem;
          color: #ffe1ac;
          z-index: 1;
        }
        .mask {
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(35, 36, 47, 0.3);
          z-index: 1;
        }
        .img {
          width: 0.6rem;
          z-index: 1;
        }
        .select {
          width: 0.84rem;
          height: 0.17rem;
          position: absolute;
          top: 0;
          z-index: 1;
        }
      }
      .header-item-active {
        background: url(../../assets/img/dialog/mask-item.png) no-repeat;
        background-size: 100% 100%;
        .mask {
          z-index: 0;
        }
      }
    }
    .content-panel {
      display: flex;
      padding-left: 0.1rem;
      height: 3.78rem;
      background: linear-gradient(180deg, #292935 0%, #353643 51.04%, #1c1e28 100%);
      .content-panel-left {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.72rem;
        height: 3.78rem;
        background: url(../../assets/img/dialog/item-left.png) no-repeat;
        background-size: 100% 100%;
        .img {
          width: 2rem;
        }
      }
      .content-panel-right {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        padding-top: 0.3rem;
        padding-left: 0.3rem;
        .right-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          // margin-right: 0.45rem;
          width: 1.3rem;
          img {
            width: 0.32rem;
            height: 0.32rem;
          }
          .text1 {
            color: #ffd578;
            font-size: 0.14rem;
            margin-top: 0.03rem;
          }
          .text2 {
            color: #999999;
            font-size: 0.12rem;
            margin: 0.05rem 0;
          }
          .text3 {
            color: #999999;
            font-size: 0.12rem;
          }
        }
      }
    }
    .content-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.5rem;
      height: 0.9rem;
      background: #23242f;
      .content-footer-left {
        .up {
          display: flex;
        }
        span {
          color: #ffdcac;
        }
        .down {
          margin-top: 0.12rem;
        }
      }
      .content-footer-right {
        position: relative;
        cursor: pointer;
        z-index: 1;
        .btn {
          width: 1.56rem;
        }
        .text {
          position: absolute;
          top: 0.14rem;
          left: 0.35rem;
          width: 0.82rem;
        }
      }
    }
    .e-line-panel {
      position: absolute;
      left: -0.23rem;
      top: -0.87rem;
      right: -0.23rem;
      bottom: -0.11rem;
    }
    .e-line {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
